import posthog from "posthog-js";
import { isAnalyticsEnabled } from "./analyticsGate";

const useUserAnalytics = () => {
  const trackEvent = (eventName?: string, eventProps?: Record<string, any>) => {
    // Production real-user sessions only. Impersonated sessions, internal
    // account types and every non-production environment send nothing — the
    // same rule the declarative click tracker (useEventTracker) obeys.
    if (!isAnalyticsEnabled() || !eventName) {
      return;
    }

    posthog?.capture(eventName, eventProps);
  };

  return { trackEvent };
};

export default useUserAnalytics;
